//  Loyalty.aspx
(function (backOffice, $) {
    backOffice.Loyalty = (function() {
        var scopeSelector = backOffice.options.scopeSelector;

        var expirySchedule = {
            NotExpire: 0,
            Annually: 1,
            AfterXDays: 2
        };

        var registerEvents = function () {
            $('#txtExpireDays').keyup(function() {
                $("#hdnExpireDays").val(this.value);
            });
            $('#expireAtTime').change(function () {
                $("#hdnExpireAtTime").val(this.value);
            });

            $(document).ready(function (){
                var expireDaysVal = $("#hdnExpireDays").val();
                $('#txtExpireDays').val(expireDaysVal);
            });
            $(document).ready(function () {
                var expireTime = $("#hdnExpireAtTime").val();
                $('#expireAtTime').val(expireTime);
            });
        };

        var hasAccessToChangeTime = function () {
            if ($("#IsUserRexAdmin").val() === "false")
                $('#timeExpireField').hide();
        }

        var initialise = function (options) {
            $.extend(backOffice.options, options);
            registerEvents();
            hasAccessToChangeTime();
        };

        var proceedExpirationSave = function () {
            if (Page_ClientValidate('vgExpiration')) {
                backOffice.ToggleLoader(true);
                return true;
            }

            return false;
        };

        var validateExpirySchedule = function (sender, args) {
            var expSchedVal = $("#rblExpirySchedule input[type='radio']:checked").val();

            if (+expSchedVal === expirySchedule.AfterXDays) {
                var daysVal = $("#txtExpireDays").val();

                if (daysVal === "") {
                    args.IsValid = false;
                    sender.innerText = "Days value required.";
                    return;
                }
                else if(!/^\d*[1-9]\d*$/.test(daysVal)){
                    args.IsValid = false;
                    sender.innerText = "You can only enter a positive integer.";
                    return;
                }
            }

            args.IsValid = true;
        };

        return $.extend(backOffice.Loyalty, {
            Init: initialise,
            ProceedExpirationSave: proceedExpirationSave,
            ValidateExpirySchedule: validateExpirySchedule
        });
    })();

    return backOffice.Loyalty;
})(BackOffice || {}, jQuery);